import { formatLocalizedDate } from "dash-ui";
import { getDisplayName } from "common/components/SubscriptionComponents/SubscriptionPlanCardV3/SubscriptionPlanCardV3.helpers";

export const REST_API_DOMAIN = process.env["REACT_APP_REST"];

export function formatMillisToDate(timestamp?: number) {
  if (!timestamp) return "";
  return formatLocalizedDate(timestamp, {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
}

export function formatDateString(date) {
  return formatLocalizedDate(date, {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
}

export function getPlanNameByPriceId(
  products: { name: string; stripePriceId?: string | null }[] | undefined,
  priceId?: string | null
) {
  const product = priceId
    ? products?.find((item) => item.stripePriceId === priceId)
    : undefined;
  return product ? getDisplayName(product.name) : undefined;
}
